
export const COLUMNSDOMAIN = [
    {
        Header: "Domain Name",
        Footer: "Domain Name",
        accessor: "domainName",
    },
    {
        Header: "Login URL",
        Footer: "Login URL",
        accessor: "loginUrl",
    },
    {
        Header: "Created Date",
        Footer: "Created Date",
        accessor: "createdAt",
    },
    {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
    },
   
];
